import React from 'react'
import styled from 'styled-components'

export function AuthModalBody ({ children, style, enableAutofillStyles = false }) {
  return (
    <Body
      style={style}
      data-auth-modal
      {...(enableAutofillStyles ? { 'data-auth-autofill': '' } : {})}
    >
      {children}
    </Body>
  )
}

const Body = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1.5em;
  position: relative;
  box-sizing: border-box;
  max-width: 400px;
  margin: 0 auto;
`

export default AuthModalBody
